import moment from "moment/moment";
import { useEffect, useState } from "react";
import { getHighlightedText, methodGet, methodPost } from "../helper";
import Chart from "chart.js/auto";
import { formatReponsesDrivers } from "./forms/Drivers/CompletedDrivers";
import ModalCreateLien from "../components/modals/ModalCreateLien";
import ModalQuizReponse from "../components/modals/ModalQuizReponse";
import info from "../data/formulaires.json";
import infoRacines from "../data/racines.json";
import infoEnneagrame from "../data/enneagramme.json";
import { drawRadarChart } from "./forms/formHelper";
import { formatReponsesEnneagramme } from "./forms/Enneagramme/CompletedEnneagramme";
import { formatReponsesRacines } from "./forms/Racines/CompletedRacines";

export default function Admin({}) {
  const [login, setLogin] = useState(localStorage.getItem("login") ? JSON.parse(localStorage.getItem("login")) : { user: "", password: "", logged: false });
  const [liens, setLiens] = useState(null);
  const [reponses, setReponses] = useState(null);
  const [filteredReponses, setFilteredReponses] = useState(null);
  const [search, setSearch] = useState("");
  const [showModalReponse, setShowModalReponse] = useState(null);
  const [showModalLien, setShowModalLien] = useState(false);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    if (localStorage.getItem("login")) Login();
  }, []);

  useEffect(() => {
    if (!liens)
      methodGet("getLinks.php").then((res) =>
        setLiens(res.sort((a, b) => parseInt(moment(b.date).format("YYYYMMDD")) - parseInt(moment(a.date).format("YYYYMMDD"))))
      );
  }, [liens]);

  useEffect(() => {
    if (login.logged && !reponses) {
      methodGet("read.php").then((res) =>
        setReponses(res.sort((a, b) => parseInt(moment(b.date).format("YYYYMMDD")) - parseInt(moment(a.date).format("YYYYMMDD"))))
      );
    } else if (login.logged && reponses) {
      let res = [...reponses];
      res = res.filter(
        (e) =>
          e.nom.toLowerCase().includes(search.toLowerCase()) ||
          e.societe.toLowerCase().includes(search.toLowerCase()) ||
          moment(e.date).format("DD/MM/YYYY").includes(search.toLocaleLowerCase())
      );
      setFilteredReponses(res);
    }
  }, [login, reponses, search]);

  function Login() {
    if (login.user === process.env.REACT_APP_ADMIN_USER && login.password === process.env.REACT_APP_ADMIN_PASSWORD) setLogin({ logged: true });
    localStorage.setItem("login", JSON.stringify(login));
  }

  return login.logged ? (
    <>
      <div className="flex flex-col text-center max-w-lg md:max-w-5xl mx-auto py-10 p-2 md:p-5">
        {!selected && (
          <>
            <h1 className="mb-10">Génération du lien</h1>
            <div className="flex flex-col space-y-2 w-full bg-white p-6 rounded-2xl shadow-xl mb-10">
              {!liens && <p className="text-center col-span-3 w-full">Recuperation des liens . . .</p>}
              {liens && liens.length === 0 && <p className="text-center col-span-3 w-full">Il n'y a pas de liens pour le moment</p>}
              {liens &&
                liens.map((lien) => (
                  <div className="flex flex-col items-start space-y-5 p-5 border border-palette-green rounded-lg">
                    <div className="flex w-full items-center">
                      <p className="text-2xl font-bold">{lien.societe}</p>
                      <p className="pl-2">{info.forms[lien.formType].title}</p>
                      <p className="font-semibold ml-auto mr-4">{moment(lien.date).format("DD/MM/YYYY")}</p>
                      <button
                        onClick={() => {
                          if (window.confirm("Voulez-vous vraiment supprimer ce lien ?")) {
                            methodGet("deleteLink.php?linkCode=" + lien.code);
                            setLiens([...liens.filter((e) => e.id !== lien.id)]);
                          }
                        }}
                        className="font-semibold flex space-x-1 ml-1 items-center focus:bg-red-500 focus:text-palette-grey-orange border text-red-500 border-red-500 rounded-lg px-5 py-1.5"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
                          />
                        </svg>
                      </button>
                    </div>
                    <div className="flex w-full justify-between">
                      <p className="p-1">{lien.commentaire}</p>
                      <p className="p-1">{window.location.origin + "?code=" + lien.code}</p>
                    </div>
                  </div>
                ))}
              <div className="w-full flex itemx-center justify-end">
                <button
                  onClick={() => setShowModalLien(true)}
                  className="font-semibold flex space-x-1 items-center text-white bg-palette-green rounded-lg px-5 py-2"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-6 h-6">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                  </svg>
                  <p> Créer lien</p>
                </button>
              </div>
            </div>
            <h1 className="mb-10">Dernières réponses au questionnaire</h1>
            <div className="flex items-center justify-end my-2 w-full">
              <div className="flex py-2 px-4 w-64 lg:w-2/5 items-center space-x-4 rounded-full border border-palette-green">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
                </svg>
                <input
                  placeholder="Rechercher. . ."
                  onChange={(e) => setSearch(e.target.value)}
                  value={search}
                  className="w-full placeholder:text-sm placeholder:italic bg-transparent text-lg focus:outline-0  text-gray-800"
                />
                {search !== "" && (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    className="w-5 h-5 cursor-pointer"
                    onClick={() => setSearch("")}
                  >
                    <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
                  </svg>
                )}
              </div>
            </div>
          </>
        )}
        <div className={(selected ? "flex flex-col space-y-1" : "flex flex-col md:grid md:grid-cols-2 gap-2") + " w-full bg-white p-6 rounded-2xl shadow-xl"}>
          {!filteredReponses && <p className="text-center col-span-3 w-full">Chargement des réponses . . .</p>}
          {filteredReponses && filteredReponses.length === 0 && <p className="text-center col-span-3 w-full">Il n'as pas de réponses récentes</p>}
          {filteredReponses &&
            !selected &&
            filteredReponses.map((res, k) => (
              <>
                {(k === 0 || moment(filteredReponses[k - 1].date).format("DD/MM/YYYY") !== moment(filteredReponses[k].date).format("DD/MM/YYYY")) && (
                  <p className="w-full text-left font-bold pt-5 col-span-2">{getHighlightedText(moment(res.date).format("DD/MM/YYYY"), search)}</p>
                )}
                <p className="w-full pl-4 text-left hover:underline cursor-pointer" onClick={() => setSelected(res)}>
                  {getHighlightedText(res.nom, search)} - {getHighlightedText(res.societe, search)} ({info.forms[res.formType].title})
                </p>
              </>
            ))}
          {selected && (
            <a
              className="flex items-center justify-center h-12 w-12 rounded-md hover:bg-palette-green hover:bg-opacity-10 cursor-pointer"
              onClick={() => setSelected(null)}
            >
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 15.75L3 12m0 0l3.75-3.75M3 12h18" />
              </svg>
            </a>
          )}
          {selected && (
            <div key={"res_" + selected.id} className="h-full border w-full flex flex-col p-10 mx-auto border-palette-green rounded-lg text-left">
              <div className="mb-5 flex justify-between items-center">
                <p className="text-lg font-bold">
                  {selected.nom}
                  <br />
                  {selected.societe}
                </p>
                <p className="text-right">
                  {moment(selected.date).format("DD/MM/YYYY")}
                  <br />
                  {info.forms[selected.formType].title}
                </p>
              </div>
              {selected.formType === "0" && <ReponsesDrivers reponses={selected.reponse} />}
              {selected.formType === "1" && <ReponsesRacines reponses={selected.reponse} />}
              {selected.formType === "2" && <ReponsesEnnegramme reponses={selected.reponse} />}

              {/* <div className="flex justify-end items-end mt-4">
                <a onClick={() => setShowModalReponse(selected)} className="hover:underline cursor-pointer font-semibold text-sm">
                  Voir toutes les réponses
                </a>
              </div> */}
            </div>
          )}
        </div>
      </div>
      {showModalReponse && <ModalQuizReponse info={showModalReponse} onClose={() => setShowModalReponse(null)} />}
      {showModalLien && <ModalCreateLien setShowModal={setShowModalLien} refreshLiens={() => setLiens(null)} />}
    </>
  ) : (
    <div className="flex flex-col justify-center items-center text-center space-y-20 max-w-5xl mx-auto py-10 p-5">
      <h1 className="text-5xl">Connectez-vous à votre compte administrateur</h1>
      <div className="flex flex-col items-center space-y-4">
        <div className="flex flex-col items-start space-y-1">
          <p className="font-bold">Utilisateur</p>
          <input
            onChange={(e) => setLogin({ ...login, user: e.target.value })}
            className="w-full bg-transparent text-lg border border-palette-green text-gray-900 py-1 px-2 rounded-lg"
          />
        </div>
        <div className="flex flex-col items-start space-y-1">
          <p className="font-bold">Mot de passe</p>
          <input
            type="password"
            onChange={(e) => setLogin({ ...login, password: e.target.value })}
            className="w-full bg-transparent text-lg border border-palette-green text-gray-900 py-1 px-2 rounded-lg"
          />
        </div>
        <button onClick={Login} className="font-semibold border w-fit border-palette-green text-palette-green rounded-lg px-4 py-1.5">
          Connexion
        </button>
      </div>
    </div>
  );
}

function ReponsesDrivers({ reponses }) {
  const results = formatReponsesDrivers(JSON.parse(reponses));

  return (
    <div className="flex flex-col items-center justify-center space-y-5">
      {results.map((e, k) => (
        <div id={"res_" + k} className="flex items-center w-64 space-x-2 px-2">
          <div
            id={"res_" + k + "_circle"}
            className="rounded-full w-12 h-12 flex items-center text-sm md:text-lg justify-center border-2 border-palette-green font-bold"
          >
            {e.score}
          </div>
          <p className="text-center font-semibold">{e.group}</p>
        </div>
      ))}
    </div>
  );
}

function ReponsesRacines({ reponses }) {
  const [presented, setPresented] = useState(false);
  const [results, setResults] = useState(null);

  useEffect(() => {
    if (!results) setResults(formatReponsesRacines(JSON.parse(reponses)));
    else if (!presented) {
      setPresented(true);
      drawRadarChart("parentRadarChart", [...results.map((e) => e.score)], [...results.map((e) => infoRacines.results.labels[e.group])]);
    }
  }, [results]);

  return <div id="parentRadarChart" />;
}

function ReponsesEnnegramme({ reponses }) {
  const [presented, setPresented] = useState(false);
  const [results, setResults] = useState(null);

  useEffect(() => {
    if (!results) setResults(formatReponsesEnneagramme(JSON.parse(reponses)));
    else if (!presented) {
      setPresented(true);
      drawRadarChart("parentRadarChart", [...results.map((e) => e.score)], [...results.map((e) => infoEnneagrame.results.labels[e.group])]);
    }
  }, [results]);

  return <div id="parentRadarChart" />;
}
